export default __webpack_public_path__ + "static/media/settings.321fe8e7.svg";